import { useState } from 'react';

const faqItems = [
  {
    q: "Cos'è Itaobuy Spreadsheet?",
    a: "Itaobuy Spreadsheet è una piattaforma che organizza e cataloga migliaia di prodotti in un formato facile da consultare, permettendo agli utenti di trovare rapidamente ciò che cercano con informazioni dettagliate su prezzi, qualità e recensioni.",
  },
  {
    q: "Itaobuy Spreadsheet è gratuito?",
    a: "Le informazioni e le guide presenti su questa piattaforma sono completamente gratuite. Puoi esplorare tutte le categorie e i prodotti senza alcun costo.",
  },
  {
    q: "Come utilizzare Itaobuy Spreadsheet?",
    a: "Utilizzare Itaobuy Spreadsheet è semplice: basta selezionare una categoria dal menu a discesa, esplorare i prodotti disponibili e cliccare sui link per accedere direttamente ai prodotti che ti interessano.",
  },
  {
    q: "Dove trovare i prodotti migliori?",
    a: "I prodotti migliori sono organizzati per categoria. Puoi navigare tra scarpe, abbigliamento, accessori e molto altro utilizzando il nostro menu di navigazione o i pulsanti categoria nella homepage.",
  },
  {
    q: "Itaobuy Spreadsheet è sicuro?",
    a: "Sì, la piattaforma fornisce informazioni trasparenti e verificate. Consigliamo sempre di utilizzare connessioni sicure, verificare le recensioni e proteggere i propri dati personali durante gli acquisti online.",
  },
];

export default function FAQSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(null);

  const toggle = (idx: number) => {
    setOpenIdx(openIdx === idx ? null : idx);
  };

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-12">
          Domande frequenti su Itaobuy Spreadsheet
        </h2>

        <div className="space-y-3">
          {faqItems.map((item, idx) => (
            <div key={idx} className="rounded-xl border border-background-200/70 overflow-hidden">
              <button
                onClick={() => toggle(idx)}
                className="w-full flex items-center justify-between px-5 py-4 text-left bg-background-100 hover:bg-background-200/50 transition-colors cursor-pointer"
              >
                <span className="text-sm md:text-base font-semibold text-foreground-800 pr-4">{item.q}</span>
                <span className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openIdx === idx ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-lg text-foreground-500"></i>
                </span>
              </button>
              <div className={`transition-all duration-300 overflow-hidden ${openIdx === idx ? 'max-h-96' : 'max-h-0'}`}>
                <div className="px-5 py-4 text-sm text-foreground-600 leading-relaxed bg-background-50">
                  {item.a}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}